/**
 * @generated SignedSource<<bfc23578a02be40d77871e998b6a6bf9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type StoreCalendarSubscribeInput = {
  calendarName?: string | null;
  url: string;
};
export type CalendarAddMutation$variables = {
  input: StoreCalendarSubscribeInput;
};
export type CalendarAddMutation$data = {
  readonly store: {
    readonly subscribeToCalendar: {
      readonly id: string;
      readonly store: {
        readonly calendarAddSuggestions: ReadonlyArray<{
          readonly iCalUrl: string;
          readonly title: string;
        }>;
      };
    };
  };
};
export type CalendarAddMutation = {
  response: CalendarAddMutation$data;
  variables: CalendarAddMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "CalendarSuggestion",
  "kind": "LinkedField",
  "name": "calendarAddSuggestions",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "iCalUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CalendarAddMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "StoreMutations",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "StoreCalendar",
            "kind": "LinkedField",
            "name": "subscribeToCalendar",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Store",
                "kind": "LinkedField",
                "name": "store",
                "plural": false,
                "selections": [
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CalendarAddMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "StoreMutations",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "StoreCalendar",
            "kind": "LinkedField",
            "name": "subscribeToCalendar",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Store",
                "kind": "LinkedField",
                "name": "store",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "dc6da2dd5a4bd412aa02c983ec08163b",
    "id": null,
    "metadata": {},
    "name": "CalendarAddMutation",
    "operationKind": "mutation",
    "text": "mutation CalendarAddMutation(\n  $input: StoreCalendarSubscribeInput!\n) {\n  store {\n    subscribeToCalendar(input: $input) {\n      id\n      store {\n        calendarAddSuggestions {\n          iCalUrl\n          title\n        }\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "28ad967e90aac12d03574862f4a06343";

export default node;
